import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FirmwareVersion } from "../../shared/services/firmware-update-api/firmware-update-api.service";

@Component({
  selector: 'dcc-view-core-firmware-modal',
  templateUrl: './view-core-firmware-modal.component.html',
  styleUrls: ['./view-core-firmware-modal.component.scss']
})
export class ViewCoreFirmwareModalComponent {
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();
  @Input() firmwareVersion: FirmwareVersion;

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  close() {
    this.activeModal.close(false);
  }
}
